<script>
import HsScroll from "@/base/hs-scroll/hs-scroll.vue";
import HsDialog from "@/base/hs-dialog/hs-dialog.vue";
import CDialogHeader from "@/components/c-header/c-dialog-header.vue";
import HsButton from "@/base/hs-button/hs-button.vue";
import CFrameAlert from "@/components/c-frame/c-frame-alert.vue";

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    showCarryChildInfant: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: ''
    },
    positionHeight: {
      type: String,
      default: ''
    },
    AdultAmount: {
      type: Number,
      default: 2
    },
    ChildAmount: {
      type: Number,
      default: 0
    },
    InfantAmount: { // 最大入住房间数
      type: Number,
      default: 0
    },
    maxPeopleAmount: { // 最大入住人数
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      maxTotalAmount: 9,
      minAdultAmount: 1,

      currentAdultAmount: 1,
      currentChildAmount: 0,
      currentInfantAmount: 0,
    }
  },
  computed: {
    currentShow: {
      get: function () {
        return this.show
      },
      set: function (val) {
        this.$emit('update:show', val)
      }
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.currentAdultAmount = this.AdultAmount
        this.currentChildAmount = this.ChildAmount
        this.currentInfantAmount = this.InfantAmount
        if (!this.showCarryChildInfant) {
          this.currentChildAmount = 0
          this.currentInfantAmount = 0
        }

        // 纠正人数
        if (!this.currentAdultAmount) {
          this.currentAdultAmount = 1
        }
      }
    },
    '$route.path'() {
      this.close()
    }
  },
  methods: {
    changeAdultFun(value) {
      let adult = Number(value || 0)
      let child = this.currentChildAmount
      let Infant = this.currentInfantAmount
      if (adult + child + Infant <= this.maxTotalAmount) {
        this.currentAdultAmount = value
      } else {
        let oldVal = this.currentAdultAmount
        this.currentAdultAmount = oldVal
      }
      this.$refs.vanStepper1 && this.$refs.vanStepper1.$forceUpdate()
    },

    changeChildFun(value) {
      let adult = this.currentAdultAmount
      let child = Number(value || 0)
      let Infant = this.currentInfantAmount
      if (adult + child + Infant <= this.maxTotalAmount) {
        this.currentChildAmount = value
      } else {
        let oldVal = this.currentChildAmount
        this.currentChildAmount = oldVal
      }
      this.$refs.vanStepper2 && this.$refs.vanStepper2.$forceUpdate()
    },

    changeInfantFun(value) {
      let adult = this.currentAdultAmount
      let child = this.currentChildAmount
      let Infant = Number(value || 0)
      if (adult + child + Infant <= this.maxTotalAmount) {
        this.currentInfantAmount = value
      } else {
        let oldVal = this.currentInfantAmount
        this.currentInfantAmount = oldVal
      }
      this.$refs.vanStepper3 && this.$refs.vanStepper3.$forceUpdate()
    },

    getMaxLimit (adult, child, Infant) {
      adult = Number(adult || 0)
      child = Number(child || 0)
      Infant = Number(Infant || 0)
      return this.maxTotalAmount - adult - child - Infant
    },

    openExplain () {
      let refCFrameAlert = this.$refs.refCFrameAlert
      refCFrameAlert && refCFrameAlert.show()
    },

    /** 确认 */
    confirm() {
      this.$emit('delegate', this.currentAdultAmount, this.currentChildAmount, this.currentInfantAmount)
      this.close()
    },

    /** 关闭 */
    close() {
      this.$refs.refDialog && this.$refs.refDialog.close()
    }
  },
  components: {
    CFrameAlert,
    HsScroll,
    HsDialog,
    CDialogHeader,
    HsButton
  }
}
</script>

<template>
  <hs-dialog ref="refDialog" v-model="currentShow" :position="position" :positionHeight="positionHeight">
    <div class="starAndPriceDialog" :class="{ 'hs-filter-top': position === 'top', 'van-safe-area-bottom': position !== 'top' }" @click.stop>
      <c-dialog-header :title="$t('SelectThePassenger')" @close="close"/>
      <hs-scroll class="table-view" ref="tableView">
        <ul>
          <div class="cell">
            <div class="left">
              <div class="line-cell">
                <div class="label">{{$t('Adults')}}</div>
                <div class="subtext">{{$t('AdultsDesc')}}</div>
              </div>
              <!--<div class="des">
                <div class="icon"></div>
              </div>-->
            </div>
            <div class="stepper">
              <van-stepper
                  ref="vanStepper1"
                  :value="currentAdultAmount" integer :min="minAdultAmount"
                  :max="getMaxLimit(0, currentChildAmount, currentInfantAmount)"
                  input-width="48px" button-size="32px"
                  async-change
                  @change="changeAdultFun"
              />
            </div>
          </div>
          <div class="cell" v-if="showCarryChildInfant">
            <div class="left">
              <div class="line-cell">
                <div class="label">{{$t('Children')}}</div>
                <div class="subtext">{{$t('ChildrenDesc')}}</div>
              </div>
              <div class="des" @click="openExplain">
                <div class="icon"></div>
                {{$t('ChildrenAndBabyExplain')}}
              </div>
            </div>
            <div class="stepper">
              <van-stepper
                  ref="vanStepper2"
                  :value="currentChildAmount" integer :min="0"
                  :max="getMaxLimit(currentAdultAmount, 0, currentInfantAmount)"
                  input-width="48px" button-size="32px"
                  async-change
                  @change="changeChildFun"
              />
            </div>
          </div>
          <div class="cell" v-if="showCarryChildInfant">
            <div class="left">
              <div class="line-cell">
                <div class="label">{{$t('Baby')}}</div>
                <div class="subtext">{{$t('BabyDesc')}}</div>
              </div>
              <div class="des" @click="openExplain">
                <div class="icon"></div>
                {{$t('ChildrenAndBabyExplain')}}
              </div>
            </div>
            <div class="stepper">
              <van-stepper
                  ref="vanStepper3"
                  :value="currentInfantAmount" integer :min="0"
                  :max="getMaxLimit(currentAdultAmount, currentChildAmount, 0)"
                  input-width="48px" button-size="32px"
                  async-change
                  @change="changeInfantFun"
              />
            </div>
          </div>
        </ul>
      </hs-scroll>
      <footer>
        <hs-button type="theme" width="100%" height="38px" fontSize="14px" @click="confirm">{{ $t('Confirm') }}</hs-button>
      </footer>
    </div>

    <!-- 儿童婴儿说明 -->
    <c-frame-alert
        ref="refCFrameAlert"
        :title="$t('ChildrenAndBabyExplain')"
        :url="domainNameReplace('https://h5comm.homsom.com/static/html/childAndBaby.html')"
    />
  </hs-dialog>
</template>

<style scoped lang="stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.starAndPriceDialog {
  @extend .flex-column;
  @extend .flex-start;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  background-color: $color_black_0;
  max-height: 90%;
  min-height: 40%;
  overflow-y: auto;
  border-radius: 10px 10px 0 0;

  &.hs-filter-top {
    bottom: auto;
    top: 0;
    border-radius: 0;
  }

  .table-view {
    width: 100%;
    max-height: calc(100vh - 118px);
    min-height: calc(40vh - 118px);
    overflow-y: auto;
    .cell{
      @extend .flex-between;
      @extend .hs-font-body;
      color: $color_black_600;
      padding: 15px 12px;
      >.left{
        >.line-cell{
          @extend .flex-start;
          align-items: baseline;
          >.label{
            @extend .hs-font-body;
            color: $color_black_600;
          }
          >.subtext{
            @extend .hs-font-caption-1;
            ellipsis(1);
            color: $color_black_100;
            padding-left: 4px;
          }
        }
        >.des{
          @extend .flex-start;
          @extend .hs-font-caption-1;
          color: $color_black_100;
        >.icon{
          flex-shrink: 0;
          width: 12px;
          height: 12px;
          margin-right: 4px;
          background-image: url(@/assets/image/base/warning/icons_12pt_remind.svg);
          background-size: 100% 100%;
        }
      }
    }
      >.stepper{
        flex-shrink 0;
        border: 0.5px solid $color_black_40;
        border-radius: 4px;
        >>> .van-stepper__minus, >>> .van-stepper__plus {
          background-color: $color_black_0;
          &::before {
            width: 10px;
            height: 2px;
            border-radius: 2px;
          }
          &::after{
            width: 2px;
            height: 10px;
            border-radius: 2px;
          }
        }
        >>> .van-stepper__input {
          background-color: $color_black_0;
          border-left: 0.5px solid $color_black_40;
          border-right: 0.5px solid $color_black_40;
          color: $color_black_900;
          font-size: 15px;
          font-weight: 400;
          line-height: 21px;
          text-align: center;
        }
      }
    }
  }

  footer {
    @extend .flex-between;
    width: 100%;
    box-shadow: 0 5px 10px $color_gray_layer;
    padding: 16px 12px;
    margin-bottom: 0;
    .hs-button{
      border-radius: 8px;
    }
  }
}
</style>
